import $ from 'jquery';
import MembershipUtils from './../../shared/Membership';

export default () => {
    const $ctaContainer = $('.overall-score__links');
    const $ctaElement = $ctaContainer.find('.overall-score__links__subscribe');
    const $signInButton = $ctaContainer.find('.sign-in-btn');
    const hideElementsMapping = { 'EMAIL': $signInButton, 'PRINT': $signInButton };

    MembershipUtils.hideCtaElement(hideElementsMapping);
    MembershipUtils.changeCtaElementText($ctaElement);
    $ctaContainer.show();
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/MembershipPageUpdate/overallScoreCTAUpdate.js